import React from 'react';
import PropTypes from 'prop-types';
import {connectToJSContext} from '../utils.jsx';
import { SOCIAL_ICONS } from '../constants';

const SocialIcon = ({ url, type, screenReaderText }) => (
    <a
        className={`o-icon-list__a o-icon-list__${type}`}
        href={url}
        target="_blank"
        aria-label={`${type} ${screenReaderText}`}
        data-click-type="social-network"
        data-network-name={type}
        data-network-url={url}
    >
        <span className={`fa ${SOCIAL_ICONS.ICON_MAP[type]}`} aria-hidden="true"/>
        <span className="sr-only">{type} {screenReaderText}</span>
    </a>
);

SocialIcon.propTypes = {
    url: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    screenReaderText: PropTypes.string
};

const SocialIconsList = ({ networks, screenReaderText }) => (
    <ul className="o-icon-list">
        {networks && networks.map((network, i) => (
            network.url &&
                <li className="o-icon-list__li o-icon-list__li--inline" key={i}>
                    <SocialIcon
                        url={network.url}
                        type={network.type}
                        screenReaderText={screenReaderText}
                    />
                </li>
        ))}
    </ul>
);

export default connectToJSContext(() => ({}))(SocialIconsList);



// WEBPACK FOOTER //
// ./components/social_icons/index.jsx